import React from "react";
import StreaksCard from "./components/StreaksCard/StreaksCard";
import ProjectsCard from "./components/ProjectsCard/ProjectsCard";
import ToDoListCard from "./components/ToDoListCard/ToDoListCard";
import TotalStreaksCard from "./components/TotalStreaksCard/TotalStreaksCard";
import TimeCommitmentCard from "./components/TimeCommitmentCard/TimeCommitmentCard";
import ClockCard from "./components/ClockCard/ClockCard";

const Dashboard = () => {
  return (
    <div className="p-6">
      {/* Responsive grid */}
      <div className="grid grid-cols-1 md:grid-cols-7 gap-x-[20px] gap-y-[34px] items-start">
        {/* Left column */}
        <div className="space-y-6 md:col-span-4">
            <StreaksCard />
            <ProjectsCard />
        </div>

        {/* Middle column — give it more span */}
        <div className="md:col-span-2">
            <ToDoListCard />
        </div>

        {/* Right column */}
        <div className="flex flex-col items-center lg:items-start h-full md:col-span-1">
            <div className="space-y-6 flex flex-col w-full">
            <TotalStreaksCard />
            <TimeCommitmentCard />
            <ClockCard />
            </div>
            <div className="flex-1" />
        </div>
        </div>

    </div>
  );
};

export default Dashboard;
